export default __webpack_public_path__ + "static/media/BMJ.6b075c9e.png";